import React, { useEffect } from "react";
import { Paper, Tab, Tabs } from "@material-ui/core";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";

import history from "appHistory";
import { useGetSelectedTabFromRoute } from "hooks/useGetSelectedTabFromRoute";
import { getLivestockRoute } from "lib/navigation";

import { NLISHoldings } from "./NLISHoldings";

interface LivestockTab {
  label: string;
  component: React.ComponentType;
}

const tabs = [
  {
    label: "NLIS Holdings",
    component: NLISHoldings,
  },
];

export function Livestock(): React.JSX.Element {
  const match = useRouteMatch();

  const currentTab = useGetSelectedTabFromRoute(tabs);

  useEffect(() => {
    if (!currentTab && tabs[0]?.label) {
      history.push(getLivestockRoute(tabs[0].label));
    }
  }, [currentTab]);

  const routeMap = ({ label, component }: LivestockTab) => (
    <Route path={`${match.path}${label}/`} component={component} key={label} />
  );

  const tabMap = ({ label }: LivestockTab) => (
    <Tab
      label={label}
      key={`tab-${label}`}
      value={label}
      data-tour={label}
      component={Link}
      to={`${match.path}${label}/`}
    />
  );

  return (
    <>
      <Paper>
        <Tabs value={currentTab} variant="scrollable">
          {tabs.map(tabMap)}
        </Tabs>
      </Paper>

      <Switch>{tabs.map(routeMap)}</Switch>
    </>
  );
}
